import axios from "axios";
import { urlDomain } from "../config/constant";

const apiDomain = urlDomain();

// Asks the server whether the logged-in employee may run privileged operations
// (call-details export, spam-user unblock). Advisory only — it drives button
// state so the list of allowed employees no longer ships in the bundle. The
// server enforces the same policy on each route, so a caller who ignores this
// still gets a 403.
export const getMyPermissions = () => {
  const apiUrl = `${apiDomain}/me/permissions`;
  return axios.get(apiUrl, { withCredentials: true });
};
